import React, { useEffect, useState } from "react";
import { Button, Col, Card, CardBody, Input, Row } from "reactstrap";
import _ from "lodash";
import { LabelSwitch } from "./";
import { api, constants, dateHelpers } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomerTypeahead from "./CustomerTypeahead";

export default function PalletLabels() {
   const [allPrinters, setAllPrinters] = useState([]);
   const [caseDownloading, setCaseDownloading] = useState(false);
   const [caseLabelCaseNumber, setCaseLabelCaseNumber] = useState(null);
   const [casePrintToPrinter, setCasePrintToPrinter] = useState(true);
   const [customer, setCustomer] = useState(null);
   const [disabled, setDisabled] = useState(false);
   const [items, setItems] = useState([]);
   const [numberOfLabels, setNumberOfLabels] = useState();
   const [palletDownloading, setPalletDownloading] = useState(false);
   const [palletPrinters, setPalletPrinters] = useState([]);
   const [palletPrintToPrinter, setPalletPrintToPrinter] = useState(true);
   const [resetCase, setResetCase] = useState(false);
   const [salesDownloading, setSalesDownloading] = useState(false);
   const [salesOrderCaseNumber, setSalesOrderCaseNumber] = useState(null);
   const [salesOrderNumber, setSalesOrderNumber] = useState(null);
   const [salesPrintToPrinter, setSalesPrintToPrinter] = useState(true);
   const [selectedCaseLabelPrinter, setSelectedCaseLabelPrinter] = useState(null);
   const [selectedItem, setSelectedItem] = useState(null);
   const [selectedPalletPrinter, setSelectedPalletPrinter] = useState(null);
   const [selectedShipmentLabelPrinter, setSelectedShipmentLabelPrinter] = useState(null);
   const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
   const [showPalletLabels, setShowPalletLabels] = useState(true);
   const [showReprintCaseLabel, setShowReprintCaseLabel] = useState(false);
   const [showReprintSalesOrderLabel, setShowReprintSalesOrderLabel] = useState(false);
   const [workOrders, setWorkOrders] = useState([]);

   useEffect(() => {
      document.title = `Pallet Labels`
      getPrinters();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      if (!customer?.value) { return };
      getCustomerItems();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [customer]);

   useEffect(() => {
      if (!selectedItem?.value) { return };
      getWorkOrders();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [selectedItem])

   function formatItems(list) {
      let items = _.map(list, (x) => {
         return {
            label: `${x.customerItemNumber} - (${x.specNumber}) ${x.customerItemDescription}`,
            value: x.ddlValue
         }
      });
      setItems(items);
   }

   function formatPrinters(printerArr) {
      let palletPrinters = _.map(printerArr.labels, (x) => {
         return { label: x.nameOnly, value: x.id }
      });
      setPalletPrinters(palletPrinters);

      let allPrinters = _.concat(printerArr.labels, printerArr.lasers, printerArr.parts);
      let printers = _.map(allPrinters, (x) => {
         return { label: x.nameOnly, value: x.id }
      });
      setAllPrinters(printers.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0)));
   }

   function formatWorkOrders(orderArr) {
      setDisabled(false);
      if (orderArr.length) {
         let orders = _.map(orderArr, (x) => {
            return {
               label: x.lotNumber,
               value: x.lotNumber
            }
         });
         setWorkOrders(orders);
      } else {
         setSelectedWorkOrder([{
            label: "No Work Orders Found for this item",
            value: -1
         }]);
         setDisabled(true);
      }
   }

   function getCustomerItems() {
      api
         .fetch(`Customer/GetAllCustomerItems/${customer?.value}`)
         .then((response) => {
            if (response && response.data?.success) {
               formatItems(response.data.message);
            } else {
               toast.error("Failed to get customer items.")
            }
         })
         .catch(api.catchHandler);
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response && response.data?.success) {
               formatPrinters(response.data);
            } else {
               toast.error("Failed to get Printers.")
            }
         })
         .catch(api.catchHandler);
   }

   function getWorkOrders() {
      let payload = {
         customerId: customer.value,
         itemNumber: selectedItem.value
      };
      api
         .post("Production/GetWorkOrderCaseInfo", payload)
         .then((response) => {
            if (response && response.data?.success) {
               formatWorkOrders(response.data.message);
            } else {
               toast.error("Failed to get Work Orders");
            }
         })
         .catch(api.catchHandler);
   }

   function onChangeCustomer(e) {
      setCustomer(e);
      setItems([]);
      setSelectedItem(null);
      setWorkOrders([]);
      setSelectedWorkOrder(null);
      setDisabled(false);
   }

   function printPalletLabel() {
      setPalletDownloading(true);
      let payload = {
         customerId: customer?.value,
         lotNumber: selectedWorkOrder?.value,
         printerName: selectedPalletPrinter?.label,
         numberOfLabels: numberOfLabels,
         printerId: selectedPalletPrinter?.value
      };
      if (palletPrintToPrinter) {
         api
            .post("Printer/PrintPalletLabel", payload)
            .then((response) => {
               if (response && response.data && response.data.success) {
                  toast.success("Labels sent to the printer.");
               } else {
                  toast.warning(response?.data?.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setPalletDownloading(false));
      } else {
         api
            .postDownloadBinary(
               "Printer/PrintPalletLabelPDF",
               payload,
               constants.MIME_TYPES.pdf,
               `PalletLabel_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the Pallet Label."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setPalletDownloading(false));
      }
   }

   function printSalesShipmentLabel() {
      setSalesDownloading(true);
      let payload = {
         caseNumber: salesOrderCaseNumber,
         workOrderNumber: salesOrderNumber ? salesOrderNumber : "",
         printerId: selectedShipmentLabelPrinter.value,
         printerName: selectedShipmentLabelPrinter.label
      };
      if (salesPrintToPrinter) {
         api
            .post("Printer/PrintSalesShipmentLabel", payload)
            .then((response) => {
               if (response && response.data && response.data.success) {
                  toast.success("Label(s) sent to printer.");
               } else {
                  toast.error(response?.data?.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setSalesDownloading(false));
      } else {
         api
            .postDownloadBinary(
               "Printer/PrintSalesShipmentLabelPDF",
               payload,
               constants.MIME_TYPES.pdf,
               `ShipmentLabel_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the Sales Shipment Label."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setSalesDownloading(false));
      }
   }

   function reprintCaseLabel() {
      setCaseDownloading(true);
      let payload = {
         caseNumber: caseLabelCaseNumber,
         printerId: selectedCaseLabelPrinter?.value,
         printerName: selectedCaseLabelPrinter?.label,
         resetStatus: resetCase,
         printToPrinter: casePrintToPrinter
      };
      if (casePrintToPrinter) {
         api
            .post("Printer/PrintCaseLabel", payload)
            .then((response) => {
               if (response && response.data && response.data.success) {
                  toast.success("Labels sent to the printer.");
               } else {
                  toast.error(response?.data?.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setCaseDownloading(false));
      } else {
         api
            .postDownloadBinary(
               "Printer/PrintCaseLabel",
               payload,
               constants.MIME_TYPES.pdf,
               `CaseLabel_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the Case Label."
            )
            .then((response) => {
               if (response?.data === false) {
                  toast.error(response.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setCaseDownloading(false));
      }
   }

   return (
      <DesktopContainer screenName="Pallet Labels">
         <div className="filter-header sticky-top">
            <div className="dashboard-button-container">
               <Button
                  children={"Pallet Labels"}
                  className="filter-button"
                  onClick={() => setShowPalletLabels(!showPalletLabels)}
                  active={showPalletLabels}
               />
               <Button
                  children={"Reprint Case Label"}
                  className="filter-button"
                  onClick={() => setShowReprintCaseLabel(!showReprintCaseLabel)}
                  active={showReprintCaseLabel}
               />
               <Button
                  children={"Reprint Sales Order Label"}
                  className="filter-button"
                  onClick={() => setShowReprintSalesOrderLabel(!showReprintSalesOrderLabel)}
                  active={showReprintSalesOrderLabel}
               />
            </div>
         </div>
         {showPalletLabels ? (
            <Card className="dashboard-card">
               <CardBody>
                  <div>
                     <span className="h2 me-2">Pallet Labels</span>
                  </div>
                  <hr />
                  <Row className="mt-3 d-flex justify-content-center align-items-center">
                     <Col xs="6">
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Customer:</p>
                           </Col>
                           <Col xs="7">
                              <CustomerTypeahead
                                 value={customer || ""}
                                 onChange={(e) => onChangeCustomer(e)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Item:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={items}
                                 value={selectedItem}
                                 onChange={(e) => setSelectedItem(e)}
                                 isClearable={true}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>WO #:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={workOrders}
                                 value={selectedWorkOrder}
                                 onChange={(e) => setSelectedWorkOrder(e)}
                                 disabled={disabled}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-item-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Printer:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={palletPrinters}
                                 value={selectedPalletPrinter}
                                 onChange={(e) => setSelectedPalletPrinter(e)}
                                 isClearable={true}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}># of Labels:</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={numberOfLabels || ""}
                                 onChange={(e) => setNumberOfLabels(e.target.value)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3">
                           </Col>
                           <Col xs="9">
                              {/* <Button
                                        className="shredButton"
                                        disabled={!selectedWorkOrder}
                                        onClick={() => printPalletLabel()}
                                        >
                                            Print Label
                                        </Button> */}
                              <LabelSwitch
                                 displayName="Print to Printer?"
                                 buttonLabel="PRINT LABEL"
                                 onChangeCallback={(e) => setPalletPrintToPrinter(e)}
                                 onButtonClick={printPalletLabel}
                                 disabled={palletDownloading}
                              />
                           </Col>
                        </Row>
                     </Col>
                  </Row>
               </CardBody>
            </Card>
         ) : null}
         {showReprintCaseLabel ? (
            <Card className="dashboard-card">
               <CardBody>
                  <div>
                     <span className="h2 me-2">Reprint Case Label</span>
                  </div>
                  <hr />
                  <Row className="mt-3 d-flex justify-content-center align-items-center">
                     <Col xs="6">
                        <Row className="mt-3 d-flex align-item-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Case #:</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={caseLabelCaseNumber}
                                 onChange={(e) => setCaseLabelCaseNumber(e.target.value)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <Input
                                 type="checkbox"
                                 checked={resetCase}
                                 className="me-3"
                                 onChange={() => setResetCase(!resetCase)}
                              />
                           </Col>
                           <Col xs="7">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Reset Case Status to Added to Inventory</p>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-item-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Printer:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={allPrinters}
                                 value={selectedCaseLabelPrinter}
                                 onChange={(e) => setSelectedCaseLabelPrinter(e)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3">
                           </Col>
                           <Col xs="9">
                              {/* <Button
                                    className="shredButton"
                                    onClick={() => reprintCaseLabel()}
                                    disabled={downloading}
                                    >
                                        REPRINT CASE LABEL
                                    </Button> */}
                              <LabelSwitch
                                 displayName="Print to Printer?"
                                 buttonLabel="REPRINT CASE LABEL"
                                 onChangeCallback={(e) => setCasePrintToPrinter(e)}
                                 onButtonClick={reprintCaseLabel}
                                 disabled={caseDownloading}
                              />
                           </Col>
                        </Row>
                     </Col>
                  </Row>
               </CardBody>
            </Card>
         ) : null}
         {showReprintSalesOrderLabel ? (
            <Card className="dashboard-card">
               <CardBody>
                  <div>
                     <span className="h2 me-2">Reprint Sales Order Label</span>
                  </div>
                  <Row className="mt-3 d-flex justify-content-center align-items-center">
                     <Col xs="6">
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Case #:</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={salesOrderCaseNumber}
                                 onChange={(e) => setSalesOrderCaseNumber(e.target.value)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Order #:</p>
                           </Col>
                           <Col xs="7">
                              <Input
                                 type="text"
                                 value={salesOrderNumber}
                                 onChange={(e) => setSalesOrderNumber(e.target.value)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex align-items-center">
                           <Col xs="3" className="d-flex justify-content-end">
                              <p className="m-0" style={{ fontSize: "1.25rem" }}>Printer:</p>
                           </Col>
                           <Col xs="7">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={allPrinters}
                                 value={selectedShipmentLabelPrinter}
                                 onChange={(e) => setSelectedShipmentLabelPrinter(e)}
                              />
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex justify-content-end align-items-center">
                           <Col xs="3"></Col>
                           <Col xs="9" className="d-flex p-1 ms-2">
                              {/* <Button
                                        className="shredButton"
                                        onClick={() => printSalesShipmentLabelPDF()}
                                        disabled={downloading}
                                        >
                                            REPRINT SALES SHIPMENT LABEL
                                        </Button> */}
                              <LabelSwitch
                                 displayName="Print to Printer?"
                                 buttonLabel="REPRINT SALES SHIPMENT LABEL"
                                 onChangeCallback={(e) => setSalesPrintToPrinter(e)}
                                 onButtonClick={printSalesShipmentLabel}
                                 disabled={salesDownloading}
                              />
                           </Col>
                           {/* <Col xs="2"></Col> */}
                        </Row>
                     </Col>
                  </Row>
               </CardBody>
            </Card>
         ) : null}
      </DesktopContainer>
   );
}